import { defineMessages, useIntl } from "react-intl";
import { LatLngExpression } from "leaflet";
import { IconMapPinFilled } from "@tabler/icons-react";
import { pages } from "../i18n/sharable-defs";
import { Wrapper } from "../components/layout/wrapper";
import SeoMetas from "../components/layout/seo-metas";
import Elsje from "../components/common/elsje";
import ContactForm from "../components/contact-form";
import MapBlocker from "../components/common/map-blocker";
import { MapMarker } from "../bundles/map";
import PageHero from "../components/layout/page-elements/page-hero";
import heroImg from "../assets/bg-images/hero-contact.webp";
import "./contact.scss";

const transDefs = defineMessages({
  title: { id: "contact.title", defaultMessage: "Rencontrons-nous !" },
  subTitle: { id: "contact.sub-title", defaultMessage: "{name} s'engage à vous rappeler dans les 24H." },
  text: { id: "contact.text", defaultMessage: "Nous nous tenons à votre entière disposition pour échanger sur votre achat ou projet. Nous vous recevons à l'agence sur rendez-vous uniquement." },
  map: { id: "contact.map.label", defaultMessage: "Vous pouvez consulter ici l'emplacement de l'agence" }
});

const ContactPage = () => {

  const intl = useIntl();
  const position = [ 46.17943429549288, 7.299823716026841 ] as LatLngExpression;

  return (
    <>

      <SeoMetas title={`${intl.formatMessage(transDefs.title)} | EV Real Estate`} />

      <PageHero title={intl.formatMessage(pages.contact)}
                background={heroImg} />

      <Wrapper.Centered className="contact content">
        <main>
          <h2>{intl.formatMessage(transDefs.title)}</h2>
          <h3>{intl.formatMessage(transDefs.subTitle, { name: "EV Real Estate & Services" })}</h3>
          <p>{intl.formatMessage(transDefs.text)}</p>
          <Elsje />
        </main>
        <aside>
          <ContactForm />
        </aside>
        <section className="map">
          <MapBlocker center={position} label={intl.formatMessage(transDefs.map)}>
            <MapMarker position={position}
                       icon={<div className="article-marker"><IconMapPinFilled size="2.5rem" /></div>} />
          </MapBlocker>
        </section>
      </Wrapper.Centered>

    </>);

}

export default ContactPage;
